// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"433":"0affbbe1","804":"8bed5bf9"}[chunkId] + ".chunk.css";
};